module.exports = __webpack_public_path__ + "img/general.0a78c21a.svg";